import classNames from 'classnames/bind';
import { FaArrowUp, FaCheck } from 'react-icons/fa';
import css from './EncoderStatusIndicator.module.scss';

const cln = classNames.bind(css);

type EncoderStatusIndicatorProps = {
    variant: 'badge' | 'icon';
    status: 'optimal' | 'scaling';
};

export function EncoderStatusIndicator({ variant, status }: EncoderStatusIndicatorProps) {
    return (
        <div className={cln('indicator', `indicator--${status}`, `indicator--${variant}`)}>
            {status === 'scaling' ? <FaArrowUp /> : <FaCheck />}
            {variant === 'badge' && (status === 'scaling' ? 'Scaling up' : 'Optimal')}
        </div>
    );
}
